"use strict";
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCtx = exports.ctx = exports.setCanvas = exports.canvas = void 0;
var setCanvas = function (el) { exports.canvas = el; };
exports.setCanvas = setCanvas;
var setCtx = function (context) { exports.ctx = context; };
exports.setCtx = setCtx;
